module.exports = __webpack_public_path__ + "static/media/pionex.e1979d8d.png";